import React, { createContext } from 'react'
import { ICostWorksModalProps } from '@root-gipro/context/modal.props'

export const ModalContext = createContext<Partial<ICostWorksModalProps>>({})
